import * as types from './types';

export const fetchLead = (variables) => {
  return {
    type: types.FETCH_LEAD,
    payload: variables,
  };
};

export const updateLead = (variables) => {
  return {
    type: types.UPDATE_LEAD,
    payload: variables,
  };
};

export const addLead = (variables) => {
  return {
    type: types.ADD_LEAD,
    payload: variables,
  };
};

export const deleteLead = ({ id }) => {
  return {
    type: types.DELETE_LEAD,
    payload: { id },
  };
};

export const deleteLeadContactData = (orgId, leadId, contactId, type) => {
  return {
    type: types.DELETE_LEAD_CONTACT_DATA,
    payload: { orgId, leadId, contactId, type },
  };
};

export const getLeadComments = ({ orgId, leadId }) => ({
  type: types.GET_LEAD_COMMENTS,
  payload: { orgId, leadId },
});

export const createLeadComment = ({ orgId, leadId, comment }) => ({
  type: types.CREATE_LEAD_COMMENT,
  payload: { orgId, leadId: parseInt(leadId, 10), comment },
});

export const updateLeadComment = ({ orgId, leadId, commentId, comment }) => ({
  type: types.UPDATE_LEAD_COMMENT,
  payload: { orgId, leadId: parseInt(leadId, 10), commentId, comment },
});

export const deleteLeadComment = ({ orgId, leadId, commentId }) => ({
  type: types.DELETE_LEAD_COMMENT,
  payload: { orgId, leadId: parseInt(leadId, 10), commentId },
});

export const getChecklistItems = ({ orgId, leadId }) => {
  return {
    type: types.GET_CHECKLIST_ITEMS,
    payload: { orgId, leadId },
  };
};

export const updateChecklistItem = (variables) => {
  return {
    type: types.UPDATE_CHECKLIST_ITEM,
    payload: variables,
  };
};

export const reorderChecklistItem = (variables) => {
  return {
    type: types.REORDER_CHECKLIST_ITEM,
    payload: variables,
  };
};

export const  getChecklistComments = (orgId, leadId, checklistItemId) => {
  return {
    type: types.GET_CHECKLIST_COMMENTS,
    payload: { orgId, leadId, checklistItemId },
  };
};

export const createLeadChecklistItem = (orgId, leadId, referenceId) => {
  return {
    type: types.CREATE_CHECKLIST_ITEM,
    payload: { orgId, leadId, referenceId },
  };
};

export const deleteLeadChecklistItem = (orgId, leadId, checklistItemId) => {
  return {
    type: types.DELETE_CHECKLIST_ITEM,
    payload: { orgId, leadId, checklistItemId },
  };
};

export const deleteQuote = (orgId, quoteId, leadId) => ({
  type: types.DELETE_QUOTE,
  payload: { orgId, quoteId, leadId },
});

export const deleteInvoice = (orgId, invoiceId, leadId) => ({
  type: types.DELETE_INVOICE,
  payload: { orgId, invoiceId, leadId },
});

export const addChecklistAssignment = (orgId, leadId, loginId, taskId) => ({
  type: types.ADD_CHECKLIST_ASSIGNMENT,
  payload: { orgId, leadId, loginId, checklistItemId: taskId },
});

export const removeChecklistAssignment = (orgId, leadId, loginId, taskId) => ({
  type: types.REMOVE_CHECKLIST_ASSIGNMENT,
  payload: { orgId, leadId, loginId, checklistItemId: taskId },
});

export const addChecklistComment = (orgId, leadId, checklistItemId, comment) => ({
  type: types.ADD_CHECKLIST_COMMENT,
  payload: { orgId, leadId, checklistItemId, comment },
});

export const updateChecklistComment = (orgId, leadId, checklistItemId, commentId, comment) => ({
  type: types.UPDATE_CHECKLIST_COMMENT,
  payload: { orgId, leadId, checklistItemId, commentId, comment },
});

export const deleteChecklistComment = (orgId, leadId, checklistItemId, commentId) => ({
  type: types.DELETE_CHECKLIST_COMMENT,
  payload: { orgId, leadId, checklistItemId, commentId },
});

export const getChecklistReminders = (orgId, leadId, taskId) => ({
  type: types.GET_CHECKLIST_REMINDERS,
  payload: { orgId, leadId, taskId },
});

export const createChecklistReminder = (orgId, leadId, taskId, input) => ({
  type: types.CREATE_CHECKLIST_REMINDER,
  payload: { orgId, leadId, taskId, input },
});

export const updateChecklistReminder = (orgId, leadId, taskId, reminderId, input) => ({
  type: types.UPDATE_CHECKLIST_REMINDER,
  payload: { orgId, leadId, taskId, reminderId, input },
});

export const deleteChecklistReminder = (orgId, leadId, taskId, reminderId) => ({
  type: types.DELETE_CHECKLIST_REMINDER,
  payload: { orgId, leadId, taskId, reminderId },
});

export const deleteDocument = (orgId, documentId, leadId) => ({
  type: types.DELETE_DOCUMENT,
  payload: { orgId, documentId, leadId },
});

/**
 *
 * @param {Object} payload - payload for updating a custom field.
 * @param {number} payload.orgId - the id of the org that contains the lead.
 * @param {number} payload.leadId - the id of the lead to work on.
 * @param {number} payload.id - id of custom field to update.
 * @param {number} payload.urlId - an additional id for custom fields that are nested.
 * @param {object} payload.fieldState - the data to update the custom field with.
 * @returns {object} - the object to dispatch.
 */
export const updateCustomFieldData = (payload) => {
  return {
    type: types.UPDATE_CUSTOM_FORM_FIELD_DATA,
    payload,
  };
};

/**
 * @param {Object} payload - payload for updating a custom field.
 * @param {number} payload.orgId - the id of the org that contains the lead.
 * @param {number} payload.leadId - the id of the lead to work on.
 * @param {number} payload.templateId - the id of the template to generate the checklist from.
 * @returns {object} - the object to dispatch.
 */
export const createChecklistFromTemplate = (payload) => {
  return {
    type: types.CREATE_CHECKLIST_FROM_TEMPLATE,
    payload,
  };
};
